var contentElements = {
  hoverVideoCells: document.querySelectorAll(".js-content-hover-video"),
  hoverVideo: document.querySelectorAll(".js-content-hover-video > .media-video").length,
  lifestyleSlide: document.querySelector('.js-lifestyle-slide')
};

if (contentElements.hoverVideo > 0) {
  contentElements.hoverVideoCells.forEach((hoverVideoCell) => {
    const video = hoverVideoCell.querySelector("video");
    video.addEventListener("mouseover", function (e) { 
      e.target.play();
    });
    video.addEventListener("mouseout", function (e) {
      e.target.pause();
    });
  });
}

if(contentElements.lifestyleSlide){
  const arrowNext = contentElements.lifestyleSlide.getAttribute('data-arrow-next');
  const arrowPrev = contentElements.lifestyleSlide.getAttribute('data-arrow-prev');
  var lifeStyleSlide = $(contentElements.lifestyleSlide).slick({
    infinite: true,
    arrows: false,
    dots: false
  });
  $('body').on('click', '.' + arrowNext, function(){
    lifeStyleSlide.slick('next');
  });
  $('body').on('click', '.' + arrowPrev, function(){
    lifeStyleSlide.slick('prev');
  })
}